import React, { useEffect, useState } from "react";
import { IconButton, Container, Box, LinearProgress } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CancelIcon from '@mui/icons-material/Cancel';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import apiClient from "../api/apiClient";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { uD } from '../context/DC';
import { useNavigate } from 'react-router-dom';

const CheckDebt = () => {  
  const token = localStorage.getItem("token");
  const { mG } = uD();
  const [pg, sP] = useState(0); 
  const [ld, sL] = useState(true); 
  const [d, sD] = useState([]);
  const [s, sS] = useState([]);
  const navigate = useNavigate();

  const fD = async () => {
    sL(true);   
    sP(0); 
    sD([]); 
    try {      
      let r = await apiClient.get("/api-data/file-getlist", {headers: {'s': '0019',  "Authorization": `Bearer ${token}` ,},});
      if (r.data.s=='0' && r.data.d.rowCount > 0) { 
        sD(r.data.d.rows);
        sS([]);
      } else if (r.data.s=='0' && r.data.d.rowCount == 0) {
        await mG({t: "Warning",tc: "#ffa000",m: "ไม่พบข้อมูล",bt: "OK",btc: "white",bc: "#ffb300",bch: "#ff6f00",}); 
      } else {
        await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      } 
    } catch (error) {
      let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    }
    sL(false);
    sP(100);
  };

  useEffect(() => {
    fD();
  }, []);

const hCbS = (d) => {
  sS((prevSelected) =>
      prevSelected.some((f) => f.c2 === d.c2)
          ? prevSelected.filter((f) => f.c2 !== d.c2)
          : [...prevSelected, d]
  );
};

const hCbA = () => {
  if (s.length === d.length) {
      sS([]); 
  } else {
      sS([...d]); 
  }
};

const hD = async (s) => {
  sL(true);   
  sP(0); 
  try {
    const i = await mG({t: "Delete",tc: "#e40000",m: "คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธไฟล์นี้?",bt: "Cancel",btc: "white",bc: "#66bb49",bch: "#3f762c",cf: true,bcfc: "#ff1616",bcfh: "#d40000",bcft: "Confirm",}); 
    if (i) { 
      const r = await apiClient.post("/api-data/file-reject", s, {
        headers: {'s': '0019',  "Authorization": `Bearer ${token}` ,},});
      if (r.data.s === "0") {
        await mG({t: "Completed",tc: "#519a39",m: r.data.m,bt: "OK",btc: "white",bc: "#66bb49",bch: "#3f762c",});         
        sD((prevFiles) => prevFiles.filter((f) => f.c2 !== s.c2));
        sS((prevSelected) => prevSelected.filter((f) => f.c2 !== s.c2));
      } else {
        await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      }  
    } 
  } catch (error) {
    let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
  }
  sL(false);
  sP(100);
};

const hDS = async () => {
  sL(true);   
  sP(0); 
  try {
    if (s.length === 0) {
      await mG({t: "Failed",tc: "#e40000",m: "กรุณาเลือกอย่างน้อย 1 รายการ",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      return;
    }
    const i = await mG({t: "Delete",tc: "#e40000",m: "คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธไฟล์นี้?",bt: "Cancel",btc: "white",bc: "#66bb49",bch: "#3f762c",cf: true,bcfc: "#ff1616",bcfh: "#d40000",bcft: "Confirm",}); 
    if (i) { 
      const r = await apiClient.post("/api-data/file-reject", s, {
        headers: {'s': '0019',  "Authorization": `Bearer ${token}` ,},});
      if (r.data.s == "0") {
        await mG({t: "Completed",tc: "#519a39",m: r.data.m,bt: "OK",btc: "white",bc: "#66bb49",bch: "#3f762c",});         
        sD((prevFiles) => prevFiles.filter((f) => !s.includes(f)));
        sS([]);
      } else {
        for (const row of r.data.d) {
          sD((prevFiles) => prevFiles.filter((f) => f.c2 !== row));
          sS((prevSelected) => prevSelected.filter((f) => f.c2 !== row));
        }
        await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      }  
    }       
  } catch (error) {
    let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
  }
  sL(false);
  sP(100);
};

const hI = async (s) => {
  sL(true);   
  sP(0);
  try {
    const r = await apiClient.post("/api-data/file-import", s, {
        headers: {'s': '0019',  "Authorization": `Bearer ${token}` ,},});
    if (r.data.s === "0") {
      await mG({t: "Completed",tc: "#519a39",m: r.data.m,bt: "OK",btc: "white",bc: "#66bb49",bch: "#3f762c",});         
      sD((prevFiles) => prevFiles.filter((f) => f.c2 !== s.c2));
      sS((prevSelected) => prevSelected.filter((f) => f.c2 !== s.c2));
    } else {
      await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    }        
  } catch (error) {
    let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
  }
  sL(false);
  sP(100);
};

const hIS = async () => {
  sL(true);   
  sP(0);
  try {
    if (s.length === 0) {
      await mG({t: "Failed",tc: "#e40000",m: "กรุณาเลือกอย่างน้อย 1 รายการ",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      return;
    }
    const r = await apiClient.post("/api-data/file-import", s, {
      headers: {'s': '0019',  "Authorization": `Bearer ${token}` ,},});
    if (r.data.s == "0") {
      await mG({t: "Completed",tc: "#519a39",m: r.data.m,bt: "OK",btc: "white",bc: "#66bb49",bch: "#3f762c",});         
      sD((prevFiles) => prevFiles.filter((f) => !s.includes(f)));
      sS([]);
    } else {
      for (const row of r.data.d) {
        sD((prevFiles) => prevFiles.filter((f) => f.c2 !== row));
        sS((prevSelected) => prevSelected.filter((f) => f.c2 !== row));
      }
      await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    }  
      
  } catch (error) {
    let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
  }
  sL(false);
  sP(100);
};

  return (
    <Container component="main" maxWidth="96%" sx={{marginTop: "40px",border: "0px solid #e0e0e0",boxSizing: "border-box",}}>

      {/* Loading Progress Bar */}
            {ld ? (
              <Box sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                zIndex: 999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}>
                <LinearProgress variant="determinate" value={pg} sx={{ width: '50%' }} />
              </Box>
      
             ) : ( 

      <Box sx={{ width: '100%',display: "flex",flexDirection: "column", marginLeft:0, marginBottom:0, boxShadow: "none",marginTop: "0px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
        backgroundColor: "background.paper",
      }}>
        <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:0, boxShadow: "none",marginTop: "0px",
          textAlign: "center",
          verticalAlign: "middle",
          padding:1,
          backgroundColor: "#f5f5f5",
          fontSize: "calc(14px + 0.5vw)",
          fontWeight: "bold",
          color: "#333",
        }}>
          ตรวจสอบไฟล์และนำข้อมูลเข้าระบบ - ไฟล์ข้อมูลการรับชำระหนี้หรือจ่ายชำระหนี้
        </Box>

        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
          borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
        }}>
            {d.length > 0 ? (
              "กรุณาเลือกไฟล์สำหรับการนำเข้าข้อมูลหรือปฏิเสธไฟล์นั้นเพื่ออัพโหลดไฟล์ใหม่อีกครั้ง"
            ) : (
              "ไม่พบไฟล์สำหรับการนำเข้าข้อมูล กรุณาอัพโหลดไฟล์ใหม่อีกครั้ง"
            )}
        </Box>
        
        {d.length > 0 && (
        
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 400,
              overflow: "auto", // ให้ scroll แนวตั้ง
              minWidth: 800,     // บังคับให้มี scroll แนวนอนถ้าเนื้อหากว้าง
            }}
          >
            <Table size="small" aria-label="a dense table" sx={{ borderCollapse: 'collapse' }}>
            <TableHead sx={{ backgroundColor: '#f5f5f5',whiteSpace: "nowrap", }}>
                <TableRow sx={{ height: 40 }}>
                <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>
                    <input
                      type="checkbox"
                      onChange={hCbA}
                      checked={s.length === d.length}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>ลำดับ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>ข้อมูล</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>ชื่อไฟล์</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>ผู้อัพโหลด</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>อัพโหลดเมื่อ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>ตรวจข้อมูล</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>นำเข้า</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>ปฏิเสธ</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {d.map((file, index) => (
                  <TableRow sx={{ height: 40 }}
                    key={index}
                  >
                    <TableCell align="center" component="th" scope="row" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      <input
                        type="checkbox"
                        checked={s.some((f) => f.c2 === file.c2)}
                        onChange={() => hCbS(file)}
                      />
                    </TableCell>
                    <TableCell align="center" component="th" scope="row" sx={{whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {index+1}
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {file.c1}
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {file.c6}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {file.c3}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {file.c4 ? new Date(file.c4).toISOString().replace("T", " ").substring(0, 19) : ""}
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      <IconButton
                        onClick={() =>
                          navigate("/check/debt-detail", {
                            state: {
                              s: file.c2,                              
                              c6: file.c6,
                            },
                          })
                        }
                        sx={{ color: "primary.main" }}
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                    <IconButton onClick={() => hI(file)} sx={{ color: "#0061d4" }}>
                        <ImportExportIcon />
                    </IconButton>
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "pre-wrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                    <IconButton onClick={() => hD(file)} color="error">
                        <CancelIcon />
                    </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        
        {s.length > 0 && (
          <Box sx={{  marginBottom:0, boxShadow: "none",marginTop: "4px" ,boxSizing: "border-box",
            borderRadius: 0,
            padding: "4px 4px",
            textAlign: "center",
            verticalAlign: "middle",
          }}>
            <button
              onClick={hIS}
              style={{
                padding: "8px 15px",
                background: "#0061d4",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
                marginRight: "10px",
              }}
              
            >
              นำเข้าข้อมูล
            </button>

            <button
              onClick={hDS}
              style={{
                padding: "8px 15px",
                background: "#e40000",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
              }}
            >
              ปฏิเสธไฟล์
            </button>
          </Box>
        )}

      </Box>

      )}

    </Container>
  );
};

export default CheckDebt;